const concept = `
Simple Schema
`

const schema = {
  title: 'ToDo',
  properties: {
    title: {},
    todo: { items: {}}
  }
}

export default {
  concept,
  props: { schema },
}


// WEBPACK FOOTER //
// ./src/schemas/todo.js